import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { makeStyles } from '@material-ui/core/styles'
import Tab from "@material-ui/core/Tab"
import TabContext from "@material-ui/lab/TabContext"
import TabList from "@material-ui/lab/TabList"
import TabPanel from "@material-ui/lab/TabPanel"
import Container from '@material-ui/core/Container'
import AppBar from "@material-ui/core/AppBar"
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import RegisterTechnician from '../telematics/Technicians/RegisterTechnician'
import TechnicianList from './Technicians/TechnicianList'

const useStyles = makeStyles({
    stageButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    denyButton: {
        backgroundColor: "white"
    },
    cancelButton: {
        borderColor: "#7a9bc2"
    },
    deleteButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    pdfButton: {
        backgroundColor: "white"
    },
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    }
})

const TelematicsTechnicians = ({ classes, ...props }) => {
    const { t } = useTranslation()
    const localclass = useStyles()
    const [value, setValue] = useState("1")

    useEffect(() => {
        const newRoute = {
            path: '/telematics/CatalogInstaller/',
            linkLegend: t('telematicsInstallers.technicianCatalog'),
        }
        props.navigationActions.add_route(newRoute)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} >
                        <p className={classes.titles}>{t(`telematicsInstallers.technicianCatalog`)}</p>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <TabContext value={value}>
                            <AppBar position="static" elevation={0}>
                                <TabList onChange={handleChange} className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }} >
                                    <Tab label={t('telematicsInstallers.registerTechnician')} value="1" className={localclass.tab} />
                                    <Tab label={t('telematicsInstallers.technicianList')} value="2" className={localclass.tab} />
                                </TabList>
                            </AppBar>
                            <TabPanel value="1" className={classes.paddingTabPanel}>
                                <RegisterTechnician {...props} />
                            </TabPanel>
                            <TabPanel value='2' className={classes.paddingTabPanel}>
                                <TechnicianList {...props} />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsTechnicians))